module.exports = "/static/Images/images/flag-es.png";